module.exports = __webpack_public_path__ + "static/img/pddbg2.b049d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/pddbg2.png
// module id = 1256
// module chunks = 0